import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="hb-empty hb-404">
      <h1>This movie is not currently in stock.</h1>
      <p>Try the front of the store.</p>
      <Link to="/" className="hb-chip is-active">← Back to The Floor</Link>
    </div>
  );
}
